export const FarmsFarmBoxData = [
	{
		id: 12105,
		name: "Fazenda Biguá",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: false
	},
	{
		id: 11948,
		name: "Fazenda Eldorado",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: false
	},
	{
		id: 11949,
		name: "Fazenda Fazendinha",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: false
	},
	{
		id: 11942,
		name: "Fazenda Lago Verde",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: true
	},
	{
		id: 12104,
		name: "Fazenda Pau Brasil",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: false
	},
	{
		id: 11946,
		name: "Fazenda Benção de Deus",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: true
	},
	{
		id: 11945,
		name: "Fazenda Cacique",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: true
	},
	{
		id: 11944,
		name: "Fazenda Campo Guapo",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: true
	},
	{
		id: 11936,
		name: "Fazenda Safira",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: true
	},
	{
		id: 11950,
		name: "Fazenda Novo Acordo",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: false
	},
	{
		id: 11943,
		name: "Fazenda Praia Alta",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: false
	},
	{
		id: 11951,
		name: "Fazenda Ouro Verde",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: false
	},
	{
		id: 12103,
		name: "Fazenda 5 Estrelas ",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: false
	},
	{
		id: 11947,
		name: "Fazenda Santa Maria",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: true
	},
	{
		id: 11939,
		name: "Fazenda Capivara",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: true
	},

	{
		id: 11940,
		name: "Fazenda Tuiuiu",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: true
	},
	{
		id: 11941,
		name: "Fazenda Cervo",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: true
	},
	{
		id: 11937,
		name: "Fazenda Tucano",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: true
	},
	{
		id: 11938,
		name: "Fazenda Jacaré",
		cnpj_cpf: "",
		ie: "",
		city: null,
		show: true
	}
];
